import React, { memo } from 'react';
import { Hidden } from 'native-base';
import { CTALink } from '../../atoms/CTALink';
import { AnchorText } from '../../atoms/AnchorText';
import { LinkText } from '../../atoms/LinkText/';
import Typography from '../../atoms/Typography/Typography';
import { DeepLink } from '../../atoms/DeepLink';
import DialInText from '../../atoms/DialInText/DialInText';
const RenderByContentType = /*#__PURE__*/memo(_ref => {
  let {
    type,
    content,
    metadata = {},
    event
  } = _ref;
  switch (type) {
    case 'cta-link':
      return /*#__PURE__*/React.createElement(CTALink, {
        key: content,
        content: content,
        metadata: metadata,
        event: event
      });
    case 'link':
      return /*#__PURE__*/React.createElement(AnchorText, {
        key: content,
        content: content,
        metadata: metadata,
        event: event
      });
    case 'dial-in':
    case 'freedom-dial-in':
      return /*#__PURE__*/React.createElement(DialInText, {
        key: content,
        content: content,
        metadata: {
          ...metadata,
          fontWeight: 'medium'
        },
        type: type,
        event: event
      });
    case 'separator':
      return /*#__PURE__*/React.createElement(Hidden, {
        till: "lg"
      }, /*#__PURE__*/React.createElement(Typography, {
        key: content,
        content: content,
        metadata: {
          ...metadata,
          fontWeight: 'medium'
        }
      }));
    case 'cta-terms-link':
      return /*#__PURE__*/React.createElement(DeepLink, {
        key: content,
        content: content,
        metadata: {
          ...metadata,
          fontSize: 'xs',
          fontWeight: 'medium',
          type
        },
        event: event
      });
    case 'cta-deep-link':
      return /*#__PURE__*/React.createElement(DeepLink, {
        key: content,
        content: content,
        metadata: {
          ...metadata,
          fontSize: 'lg',
          fontWeight: 'medium'
        },
        event: event
      });
    case 'linkText':
      return /*#__PURE__*/React.createElement(LinkText, {
        key: content,
        content: content,
        metadata: {
          ...metadata,
          fontSize: '16'
        },
        event: event
      });
    default:
      return /*#__PURE__*/React.createElement(Typography, {
        key: content,
        content: content,
        metadata: metadata
      });
  }
});
export default RenderByContentType;
//# sourceMappingURL=RenderByContentType.js.map